var flag = false;
$(document).ready(function(){

   function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }
   
   
   $('.addtocart').click(function(e) {
      e.preventDefault();
      $(this).prop('disabled', true);
      $(this).addClass('just-clicked');
      addItem($(this).closest("form").attr('id'));
      //addItem('add-item-form');d
   });   
   

   Shopify.onSuccess = function() {

      var elem = $('.addtocart.just-clicked');
      var img_cart = elem.parent().find('.image-cart').val();
      var name_cart = elem.parent().find('.name-cart').val(); 

      elem.removeAttr("disabled");
      elem.removeClass('just-clicked');

      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
      var number =0;
     var number1 =  parseInt($('#cart-count').text()) + quantity;

     if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
       $("html, body").animate({ scrollTop: 0 }, 250, 'swing');
     }

      function animate() {
        var cart = $('.smaller-cart');
        
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          $("html, body").animate({ scrollTop: 0 }, 250, 'swing');
          
          $("#cart-animation").show();

          var addToCartWidth = elem.outerWidth() / 2
          var addToCartHeight = elem.outerHeight() / 2

          var addToCartLeft = elem.offset().left + addToCartWidth;
          var addToCartTop = $(elem).offset().top + addToCartHeight ;

          console.log(cart);
          
          var addtocartWidth = elem.outerWidth() / 2
          var addtocartHeight = elem.outerHeight() / 2

          var addtocartLeft = elem.offset().left + addtocartWidth;
          var addtocartTop = $(elem).offset().top + addtocartHeight ;

          var buttonAreaWidth = $("#cart").outerWidth();
          var buttonAreaHeight = $("#cart").outerHeight();

          var buttonAreaLeft = ($("#cart").offset().left + buttonAreaWidth / 2  - $("#cart-animation").outerWidth() / 2) - 4 - 34;
          var buttonAreaTop = ($("#cart").offset().top + buttonAreaWidth / 2  - $("#cart-animation").outerHeight() / 2) - 4 - 19;

          var path = {
            start: {
              x: addtocartLeft,
              y: addtocartTop,
              angle: 190.012,
              length: 0.2
            },
            end: {
              x: buttonAreaLeft,
              y: buttonAreaTop,
              angle: 90.012,
              length: 0.50
            }
          };

          $('#cart-animation').text(quantity).animate(
            {
              path : new $.path.bezier(path)
            },
            1200,
            function() {
              $("#cart-animation").fadeOut(500, function() {
                $(elem).prop("disabled", false)
                var cartCount =  parseInt($('#cart-count').text()) + quantity;
                $('#cart-count').text(cartCount)
                $('.cart-count-smaller').text(cartCount);
                cart.addClass('has-items');
                number = cartCount;
              });
          	});
          } else {
            $(elem).prop("disabled", false)
            var cartCount =  parseInt($('#cart-count').text()) + quantity;
            number = cartCount;
            $('#cart-count').text(cartCount)
            $('.cart-count-smaller').text(cartCount);
            $('#cart-count').addClass('cart-shake');
            $('.cart-count-smaller').addClass('cart-shake');
            cart.addClass('has-items');
            setTimeout (function(){
              $('#cart-count').removeClass('cart-shake');
              $('.cart-count-smaller').removeClass('cart-shake');
            }, 800);
          }
      }

      animate();
     
     var html = '';
     html +='<li class="mini_cart_item">';
      html +='<div class="product-item-bg">';
      	html +='<img src="'+img_cart+'">';
                    html +='</div>';
                    html +='<div class="product-item-right">';
                     html +='<a href="/cart/change?line=1&amp;quantity=0" class="remove" title="Remove this item" data-product_id="928" data-product_sku=""><i class="spk-icon spk-icon-close"></i></a>';
                     html +='<a href="/products/test-product?variant=1714077171761">Test Product</a>';
                     html +='<span class="quantity">'+number1+' × <span class="woocommerce-Price-amount amount">$0.00';
                        
                       html +='</span>';
                     html +='</span>';					
                    html +='</div>';
                  html +='</li>'; 
     
    var woocommer_message = '';
    woocommer_message += '<div class="product_notification_background"><img src="'+img_cart+'" /></div>';
    woocommer_message +='<div class="product_notification_text">'+quantity+' x "'+name_cart+'" has been added to your cart.</div>';
    $('.product_notification_wrapper').html(woocommer_message);	
    $('.woocommerce-message').show();
    // $(".shopkeeper-mini-cart ul.cart_list.product_list_widget").html(html);
    // $(".shopkeeper-mini-cart").removeClass( "open");
    // 
   	Shopify.onItemAdded = function(cart) {
  		alert('There are now ' + cart.item_count + ' items in the cart.');
	};  

    setTimeout(function(){ $('.woocommerce-message').hide(); }, 6000);
     

     
     
     
    };

    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      console.log(data.message);
      console.log(data.description);
      if (data.message) {
//         if (data.description.indexOf('already sold out') > 0) {
//           	$('img.limited-stock-product').hide();
//           	$('img.out-of-stock-product').show();
//         } else if (data.description.match(/You can only add*/) || data.description.match(/are in your cart*/)) {
//           	$('img.out-of-stock-product').hide();
//           	$('img.limited-stock-product').show();
//         }
//         $('#product_stock').remodal().open();
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };
  
  jQuery('.down_qty').click(function(){
    cur_val = jQuery( jQuery(this).data('target') ).val();
    if(cur_val > 1){
      jQuery( jQuery(this).data('target') ).val( parseInt(cur_val - 1) );
    }
  });
  jQuery('.up_qty').click(function(){
    cur_val = jQuery( jQuery(this).data('target') ).val();
    jQuery( jQuery(this).data('target') ).val( parseInt(cur_val) + 1 );
  });
  
  	//DDC
  /*
  	jQuery('#create_customer').submit(function(){
        var $thisform = jQuery( this );
        var action    = $thisform.attr('action');
        var user_email = $thisform.find('#email').val();
        var user_password = $thisform.find('#password').val();
      	var user_confirmpassword = $thisform.find('#password_confirm').val();
        if( user_password == user_confirmpassword) {
			alert("tesyt");
        } else {
            $thisform.children('.alert-warning').remove();
        	$thisform.prepend('<p class="alert-warning">Password do not match</p>');
        	return false;
        }
      	
        // Ajax action
        jQuery.ajax({
            url: ajaxurl,
            data: data,
            type: 'POST',
            success: function( response ) {
            	// Parse
                var result = jQuery.parseJSON( response );
                if ( result.success == 1 ) {
                    window.location = result.redirect;
            	} else {
                    $thisform.prepend('<p>error</p>');
                    parentForm.unblock();
            	}
            }
        });
        return false;

	});*/
$('.fb-close').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
 	    $('.alert-warning').remove();
        $.fancybox.close();
});
  
  $('#add-item').click(function(e){
    var $cart = $('#shopping-cart-btn .badge');
    var $cartIcon = $('#shopping-cart-btn .glyphicon');
    var $cartQty = $cart.html();
    
    //preventing click-friendly users to add
    //too many items in a second. This also helps
    //ajax functions to wait for server response
    //when updating shopping cart. 
    //You could also use different setTimeout 
    //for ajax qty update and set flag = false in there, 
    //cause 1 item per second may not be enough for common users.

    if (flag) {
      return;
    }
    flag = true;

    //ajax code here
    $cartQty++;
    $cart.html($cartQty);

    $cartIcon.addClass('cart-run');

    $cart.addClass('cart-shake');
    $('#shopping-cart-btn').addClass('glow');

    setTimeout (function(){
    $cartIcon.removeClass('cart-run');
    $cart.removeClass('cart-shake');
      $('#shopping-cart-btn').removeClass('glow');
      flag = false;
    },800);

  });

});


jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: true,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

});

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).attr('src', newImageSrc);
  
  $(mainImageDomEl).parents('a').attr('href', newImageSrc);
  
};


jQuery(document).ready(function($){

  $("a.zoom").fb({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#product .thumbs a').on('click', function(e) {
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.featured img').last()[0]);
  } );

  

  $(".flyout").hide();

  $("#menu-toggle").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });
  
  
  
 /* $("body *").click(function(e) {
    if ( e.target.className.indexOf("woocommerce-message") < 0 ) {
        $(".shopkeeper-mini-cart").removeClass( "open");
    }
});*/
  $(".woocommerce-message").on("click", function() {
    $('.right-products .woocommerce-message').hide();
    $(".shopkeeper-mini-cart").addClass( "open");
  });
  
  

  $(".sub-menu").hide();
  $(".more").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };

})(jQuery);


/* Display product - list or grid */
function bindGrid()
{
	var view = $.totalStorage('display');
	if (!view && (typeof displayList != 'undefined') && displayList)
		view = 'list';

	if (view && view != 'grid')
		display(view);
	else
		$('.view-mode').find('.grid').addClass('active');
}

function display(display){
  if(display == 'list'){
    jQuery('#products-viewmode').removeClass().addClass('products-list');
    jQuery('.products-list > .item').each(function(index, element) {
      jQuery(element).removeClass('col-lg-4 col-md-4 col-sm-4 col-xs-6');
    });		
    $('.view-mode').find('.list').addClass('active');
    $('.view-mode').find('.grid').removeClass('active');
    $.totalStorage('display', 'list');
  }else{
  	jQuery('#products-viewmode').removeClass().addClass('row products-grid');
    jQuery('.products-grid > .item').each(function(index, element) {
      jQuery(element).addClass('col-lg-4 col-md-4 col-sm-4 col-xs-6');
    });
    $('.view-mode').find('.list').removeClass('active');
    $('.view-mode').find('.grid').addClass('active');
    $.totalStorage('display', 'grid');
  }
}
/* End Display product - list or grid */